import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { useTransition, animated } from 'react-spring';

const faqs = [
  {
    id: 'faq-0',
    question:
      'Qual a documentação necessária para concluir a contratação dos planos odontológicos da SulAmérica?',
    answer:
      'Para a contratação online via SulAmérica Odonto Fácil não é necessário o envio de documentos. É preciso apenas verificar as condições contratuais, assim como os anexos disponibilizados, e concordar com os mesmos. Lembrando que a SulAmérica Odonto pode, a qualquer momento, solicitar à contratante documentação comprobatória relativa a este contrato.',
  },
  {
    id: 'faq-1',
    question: 'Quem pode ser incluído nos planos SulAmérica Odonto?',
    answer:
      'Nossos planos destinam-se a todos vinculados à pessoa jurídica contratante. Incluindo os sócios, administradores, todos os funcionários, dependentes legais (cônjuge, companheiro(a), filhos(as), enteados(as) e tutelados(as), pai, mãe, irmãos, avós, netos(as), tios(as), sobrinhos(as), bisnetos(as), sogro(a), genro, nora, cunhados(as), padrasto e madrasta) do Beneficiário Titular. Verifique todas as condições de inclusão nas Condições Gerais do Plano.',
  },
  {
    id: 'faq-2',
    question:
      'O valor mensal dos planos varia de acordo com a faixa etária dos beneficiários?',
    answer:
      'O valor da mensalidade não varia de acordo com a faixa etária. O preço se altera conforme o plano escolhido e o número de beneficiários incluídos. Verifique nas informações de cada plano o valor da mensalidade por beneficiário.',
  },
  {
    id: 'faq-3',
    question: 'Quando será o início da vigência do plano?',
    answer:
      'O início da vigência de qualquer plano escolhido se inicia a partir da zero hora do dia subsequente à quitação bancária da 1ª fatura mensal.',
  },
  {
    id: 'faq-4',
    question: 'Qual o prazo de vigência do contrato?',
    answer:
      'A vigência do contrato dos Planos SulAmérica Odonto é de 24 meses.',
  },
  {
    id: 'faq-5',
    question: 'Quais são as coberturas dos Planos SulAmérica Odonto?',
    answer:
      'Os Planos SulAmérica Odonto PME oferecem a cobertura integral do Rol de Procedimentos da ANS (Agência Nacional de Saúde Suplementar) na segmentação odontológica, além de coberturas adicionais conforme o Plano Contratado, sendo: Documentação Ortodôntica, Ortodontia, Clareamento convencional, Clareamento a laser, Próteses e Implante.',
  },
  {
    id: 'faq-6',
    question: 'Meus colaboradores terão a carteirinha do plano?',
    answer:
      'Os beneficiários terão acesso à carteira de identificação de forma online no aplicativo SulAmérica Odonto. Além da carteirinha, o app conta com diversas funcionalidades, tais como a consulta da rede credenciada, procedimentos cobertos, reembolso e muito mais.',
  },
  {
    id: 'faq-7',
    question:
      'Como faço para consultar a rede de dentistas dos planos SulAmérica Odonto?',
    answer:
      'A rede credenciada da SulAmérica Odonto tem abrangência nacional e pode ser consultada aqui no site, no aplicativo app SulAmérica Odonto ou pelos nossos canais de atendimento. - Central de Serviços (Coberturas Contratadas, Reembolso e demais solicitações): 3003-1159 - SAC (Reclamações, Cancelamentos e Informações Institucionais): 0800-722-0504.',
  },
  {
    id: 'faq-8',
    question: 'Quero utilizar o plano, por onde devo começar?',
    answer:
      'Escolha um profissional credenciado de sua preferência, agende uma consulta e apresente sua carteirinha do plano, junto com um documento pessoal com foto. Após a realização do exame clínico, o dentista solicita o procedimento na plataforma online da SulAmérica Odonto e você pode iniciar o tratamento após a liberação.',
  },
  {
    id: 'faq-9',
    question:
      'Devo pagar algum valor adicional ao dentista credenciado no momento da utilização do plano?',
    answer:
      'Não há nenhum valor adicional para os procedimentos cobertos pelo plano contratado. Não há franquias ou coparticipação e todo o pagamento dos procedimentos cobertos será realizado pela SulAmérica Odonto diretamente ao dentista / clínica credenciada.',
  },
  {
    id: 'faq-10',
    question: 'Posso utilizar um dentista particular?',
    answer:
      'Sim. A SulAmérica Odonto disponibiliza a opção de livre escolha. Uma vez que o dentista não faz parte da nossa rede credenciada, o reembolso das despesas para todos os procedimentos cobertos no plano irá seguir a tabela estabelecida.',
  },
  {
    id: 'faq-11',
    question: 'Quais bancos são aceitos para débito em conta?',
    answer:
      'Os bancos que aceitam débito em conta são: Santander, Itaú e Bradesco.',
  },
  {
    id: 'faq-12',
    question:
      'Qual o plano SulAmérica Odonto PME que cobre a manutenção de Ortodontia e/ou Implantes?',
    answer:
      'Temos planos com cobertura de Ortodontia, Próteses e Implante, de acordo com a grade de planos: MAIS: Rol Ampliado - MAIS DOC: Rol Ampliado + Documentação Ortodôntica - MAIS CLAREAR: Rol Ampliado + Clareamento convencional - MAIS ORTO: Rol Ampliado + Ortodontia - MAIS PRO: Rol Ampliado + Próteses - MAIS AMPLO: Rol Ampliado + Orto + Próteses + Clareamento convencional - PREMIUM: Rol Ampliado + Orto + Próteses + Implante + Clareamento a laser',
  },
  {
    id: 'faq-13',
    question: 'Como faço para contratar o plano PME?',
    answer:
      '1. Cadastre as informações de sua empresa e crie o login e senha. 2. Escolha o plano de cada titular e não esqueça de incluir os dependentes. 3. Confira o resumo da proposta com atenção e, se necessário, faça as devidas alterações. Em seguida clique em "CONTRATAR". Depois de clicar em "CONTRATAR", a proposta é finalizada e não pode ser alterada. Caso queira realizar alguma alteração, será necessário o cancelamento e emissão de uma nova proposta.',
  },
  {
    id: 'faq-14',
    question:
      'Concluí a proposta de plano, mas preciso alterar os dados dos meus beneficiários. Como devo proceder?',
    answer:
      'Caso já tenha efetivado o pagamento do boleto, as orientações para realizar as alterações poderão ser solicitadas pela Central de Atendimento SulAmérica Odonto. Caso ainda não tenha pagado o boleto, basta clicar em "CANCELAR", voltar para a edição de dados do cadastro e emitir uma nova proposta (será gerada uma nova proposta e um novo boleto correspondente).',
  },
  {
    id: 'faq-15',
    question: 'Como recuperar minha senha de acesso?',
    answer:
      'Clique em "Minha Proposta", digite seu login de acesso (CNPJ) e depois clique em "Esqueci minha senha".',
  },
  {
    id: 'faq-16',
    question:
      'Tentei cadastrar minha empresa mas apareceu a mensagem de que já sou cliente. O que devo fazer?',
    answer:
      'Entre em contato com a SulAmérica nos nossos canais de atendimento: - Central de Serviços (Coberturas Contratadas, Reembolso e demais solicitações): 3003-1159 - SAC 0800-722 (Reclamações, Cancelamentos e Informações Institucionais): 0800-722-0504',
  },
];

export default function FaqOdonto() {
  const [activeIndex, setActiveIndex] = useState(null);

  const handleClick = (index) => {
    if (index === activeIndex) {
      // se o índice ativo for clicado novamente, colapsa a resposta
      setActiveIndex(null);
    } else {
      setActiveIndex(index);
    }
  };

  const transitions = useTransition(activeIndex, {
    from: { maxHeight: '0px', opacity: 0 },
    enter: { maxHeight: '1000px', opacity: 1 },
    leave: { maxHeight: '0px', opacity: 0 },
  });

  return (
    <div className="w-full bg-gray-50 py-16">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-4xl font-bold text-center mb-4 text-gray-900">
          Tire suas dúvidas
        </h2>
        <p className="text-xl text-gray-600 text-center mb-12">
          Encontre respostas para as perguntas mais frequentes sobre os planos
        </p>
        <div className="space-y-4">
          {faqs.map((faq) => (
            <div
              key={faq.id}
              className="bg-white border-2 border-orange-200 rounded-lg shadow-sm hover:shadow-md transition-shadow duration-200"
            >
              <button
                className="flex justify-between items-start cursor-pointer w-full text-left p-6"
                onClick={() => handleClick(faq.id)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    handleClick(faq.id);
                  }
                }}
                aria-expanded={faq.id === activeIndex}
                aria-controls={`answer-${faq.id}`}
              >
                <p className="font-semibold text-gray-900 pr-4">
                  {faq.question}
                </p>
                <FontAwesomeIcon
                  icon={faChevronDown}
                  className={`text-orange-600 transform transition-transform duration-200 flex-shrink-0 mt-1 ${
                    faq.id === activeIndex ? 'rotate-180' : ''
                  }`}
                />
              </button>
              {transitions(
                (style, item) =>
                  item === faq.id && (
                    <animated.div
                      style={style}
                      className="overflow-hidden"
                      id={`answer-${faq.id}`}
                    >
                      <div className="px-6 pb-6 pt-0">
                        <p className="text-gray-600 leading-relaxed">
                          {faq.answer}
                        </p>
                      </div>
                    </animated.div>
                  ),
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
